module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-7f77840e.eot";